import logoAsset from "../assets/imgs/logo.png";
import indiaMartAsset from "../assets/imgs/india_mart.png";
import tradeIndiaAsset from "../assets/imgs/tradeindia.png";
import facebookAsset from "../assets/imgs/facebook.png";
import instagramAsset from "../assets/imgs/instagram.png";
import googleAsset from "../assets/imgs/google.png";
import linkedinAsset from "../assets/imgs/linkedin.png";
import twitterAsset from "../assets/imgs/twitter.png";
import youtubeAsset from "../assets/imgs/youtube.png";
import { getAssetUrl } from "./api";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../styles/catalogueDownload.css";

/* ─── Brand tokens ─────────────────────────────────────────────── */
const B = {
  tradeName: "Krrish Ecoware Industries PVT. LTD.",
  name: "Krrish Impex",
  tagline: "Eco-Friendly Disposable Solutions Since 2001",
  tagline2: "House-Hold Disposable Cutlery & Tableware",
  obsidian: "#0D0F14",
  ink: "#1A1D26",
  ash: "#6B7280",
  white: "#FFFFFF",
  crimson: "#C41230",
  gold: "#B8922A",
  navy: "#0A3D6B",
  paperWarm: "#FAF6EF",
  paperLine: "#EDE8DF",
};

const CONTACT_INFO = [
  ["Phone", "+91 70119 49384  ·  +91 98993 73580"],
  ["Email", "support@krrishimpex.com  ·  sales@krrishimpex.com"],
  ["Address", "Gali No 4, 692/1, Dharma Raja Marg, Siraspur, Delhi 110042"],
  ["Hours", "Monday – Saturday  ·  10:00 AM – 7:00 PM"],
];

const SOCIAL_LINKS = [
  ["instagram", "Instagram"],
  ["facebook", "Facebook"],
  ["youtube", "YouTube"],
  ["google", "Google"],
  ["indiamart", "IndiaMART"],
  ["tradeindia", "TradeIndia"],
  ["linkedin", "LinkedIn"],
  ["x", "X (Twitter)"],
];

const SOCIAL_ASSETS = {
  facebook: facebookAsset,
  google: googleAsset,
  instagram: instagramAsset,
  indiamart: indiaMartAsset,
  linkedin: linkedinAsset,
  tradeindia: tradeIndiaAsset,
  x: twitterAsset,
  youtube: youtubeAsset,
};

/* ─── Helpers ──────────────────────────────────────────────────── */
const esc = (v = "") =>
  String(v)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const formatSizes = (sizes) => {
  if (!sizes) return [];
  if (Array.isArray(sizes)) return sizes.filter(Boolean);
  if (typeof sizes === "string") {
    const trimmed = sizes.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch (_) {
        return [];
      }
    }
    return trimmed.split(",").map((s) => s.trim()).filter(Boolean);
  }
  return [];
};

const formatSizeUnit = (sizeUnit) =>
  sizeUnit === "mm" ? "in mm" : "in inches";

/* ─── Shared sub-components ────────────────────────────────────── */
const socialIcon = (key) =>
  SOCIAL_ASSETS[key]
    ? `<img src="${esc(SOCIAL_ASSETS[key])}" alt="" />`
    : "";

const logoLockup = (dark = false) => `
  <div class="logo-lockup">
    <div class="logo-circle">
      <img src="${esc(logoAsset)}" alt="${esc(B.tradeName)} logo" />
    </div>
    <div class="logo-text">
      <strong style="color:${dark ? B.white : '#1A1D26'}">${esc(B.tradeName)}</strong>
      <span style="color:${dark ? "rgba(255,255,255,0.55)" : '#374151'}">${esc(B.name)}</span>
      <span style="color:${dark ? "rgba(255,255,255,0.55)" : '#6B7280'}">${esc(B.tagline2)}</span>
    </div>
  </div>`;

const contactBlock = () => `
  <div class="contact-block">
    <div class="cb-social">
      <p class="cb-label">Connect With Us</p>
      <div class="cb-icons">
        ${SOCIAL_LINKS.map(([key, label]) => `
          <div class="cb-icon-item">
            <span class="cb-icon cb-${esc(key)}">${socialIcon(key)}</span>
            <span>${esc(label)}</span>
          </div>`).join("")}
      </div>
    </div>
    <div class="cb-info">
      <p class="cb-label">Contact Information</p>
      ${CONTACT_INFO.map(([label, val]) => `
        <div class="cb-row">
          <b>${esc(label)}</b>
          <span>${esc(val)}</span>
        </div>`).join("")}
    </div>
  </div>`;

const metaRows = (product) => {
  const sizes = formatSizes(product.sizes);
  const rows = [
    product.category && ["Category", product.category],
    product.material && ["Material", product.material],
    sizes.length && [`Sizes (${formatSizeUnit(product.sizeUnit)})`, sizes.join("  ·  ")],
  ].filter(Boolean);
  if (!rows.length) return "";
  return `<div class="meta-rows">${rows.map(([label, val]) => `
    <div class="meta-row">
      <span class="mr-label">${esc(label)}</span>
      <span class="mr-val">${esc(val)}</span>
    </div>`).join("")}</div>`;
};

/* =================================================================
   PAMPHLET — luxury split-layout with full-bleed image
================================================================= */

const renderPamphlet = (product) => `
  <div class="pam-wrap">

    <!-- LEFT: light panel with product image -->
    <div class="pam-visual">
      <div class="pam-visual-top">${logoLockup(false)}</div>  <!-- Changed to false for black text -->
      <div class="pam-product-image">
        <img class="pam-product-img" src="${esc(getAssetUrl(product.image))}" alt="${esc(product.name)}" />
      </div>
      <div class="pam-corner-tl"></div>
      <div class="pam-corner-br"></div>
    </div>

    <!-- RIGHT: details panel -->
    <div class="pam-details">
      <div class="pam-details-inner">
        <div class="pam-eyebrow">
          <span class="pam-eyebrow-line"></span>
          Product Pamphlet
          <span class="pam-eyebrow-line"></span>
        </div>
        <h2 class="pam-name">${esc(product.name)}</h2>
        <p class="pam-desc">${esc(product.description || "A high-quality eco-friendly disposable product crafted for food-service, hospitality, and retail use. Manufactured to international standards from sustainable materials.")}</p>
        <div class="pam-divider"></div>
        ${metaRows(product)}
        <div class="pam-note">
          <span class="pam-note-icon">ⓘ</span>
          <p>Packing configurations and pricing may vary by order volume. Please request a quotation for accurate, tailored pricing.</p>
        </div>
        <div class="pam-details-footer">
          <div class="pam-contact-grid">
            ${CONTACT_INFO.map(([label, val]) => `
              <div class="pam-cg-row">
                <b>${esc(label)}</b>
                <span>${esc(val)}</span>
              </div>`).join("")}
          </div>
          <div class="pam-social-strip">
            ${SOCIAL_LINKS.map(([key]) => `
              <div class="pam-social-icon cb-${esc(key)}">${socialIcon(key)}</div>`).join("")}
          </div>
        </div>
      </div>
    </div>
  </div>`;

/* =================================================================
   STYLES — premium design from doc 59
================================================================= */
const getCatalogueStyles = () =>
  Array.from(document.styleSheets)
    .flatMap((sheet) => {
      try {
        return Array.from(sheet.cssRules || []).map((rule) => rule.cssText);
      } catch (_) {
        return [];
      }
    })
    .join("\n");

/* =================================================================
   ENGINE — iframe capture with html2canvas + jsPDF
================================================================= */
const openWindow = async (title, bodyHtml) => {
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.left = "-99999px";
  iframe.style.top = "0";
  iframe.style.width = "1120px";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow.document;
  doc.open();
  doc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <title>${esc(title)}</title>
        <style>${getCatalogueStyles()}</style>
      </head>
      <body>
        <main class="download-page" style="margin:0;padding:28px;background:#fff;">
          ${bodyHtml}
        </main>
      </body>
    </html>
  `);
  doc.close();

  // Wait for all images to load
  const images = Array.from(doc.images);
  await Promise.all(images.map(img => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.onload = resolve;
      img.onerror = resolve; // resolve even on error to not block
    });
  }));

  // Extra tick for layout
  await new Promise(r => setTimeout(r, 150));

  const target = doc.querySelector(".download-page");
  if (!target) {
    console.error("Target element not found");
    document.body.removeChild(iframe);
    return;
  }

  try {
    const canvas = await html2canvas(target, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      logging: false,
      windowWidth: target.scrollWidth,
      windowHeight: target.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdfWidth = canvas.width;
    const pdfHeight = canvas.height;
    const pdf = new jsPDF({
      orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
      unit: "px",
      format: [pdfWidth, pdfHeight],
      compress: true,
    });
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${title}.pdf`);
  } catch (err) {
    console.error("PDF generation failed:", err);
  } finally {
    document.body.removeChild(iframe);
  }
};

/* ─── Public API ────────────────────────────────────────────────── */
export const downloadProductPamphlet = (product) => {
  if (!product) return;
  openWindow(`${product.name} — ${B.name}`, renderPamphlet(product));
};